import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { employeesQueryOptions } from '@/entities/employee'
import { useSession } from '@/entities/session'
import { ChangePasswordForm } from '@/features/auth'
import { TelegramLink } from '@/features/telegram-link'
import { Card } from '@/shared/ui/card'
import { PageBody } from '@/shared/ui/page-body'
import { PageHeader } from '@/shared/ui/page-header'
import { Spinner } from '@/shared/ui/spinner'

export const Route = createFileRoute('/_app/settings')({
  component: SettingsPage,
})

function SettingsPage() {
  const { session } = useSession()
  const employeesQuery = useQuery(employeesQueryOptions(true))
  const me = employeesQuery.data?.find((employee) => employee.id === session?.employeeId)

  return (
    <PageBody className="gap-6">
      <PageHeader title="Настройки" {...(session ? { description: session.name } : {})} />

      {employeesQuery.isLoading || !me ? (
        <Spinner />
      ) : (
        <>
          <Card className="flex max-w-2xl flex-col gap-3">
            <h2 className="label">Телеграм</h2>
            <p className="text-sm text-text-secondary">
              Уведомления о назначенных и изменённых блоках приходят в телеграм. Ссылку нужно
              открыть самому — так адрес чата берётся из мессенджера, а не из формы.
            </p>
            <TelegramLink employee={me} />
          </Card>

          <Card className="flex max-w-2xl flex-col gap-3">
            <h2 className="label">Пароль</h2>
            <ChangePasswordForm employeeId={me.id} own />
          </Card>
        </>
      )}
    </PageBody>
  )
}
